type UseCaseChipRowProps = {
  chips?: { label: string }[];
  style?: 'tag' | 'model';
};

function splitModelChip(label: string) {
  const parts = label.split(' — ');
  if (parts.length >= 2) {
    return { name: parts[0], tag: parts.slice(1).join(' — ') };
  }
  return { name: label, tag: null };
}

export function UseCaseChipRow({ chips, style = 'tag' }: UseCaseChipRowProps) {
  if (!chips?.length) return null;

  if (style === 'model') {
    return (
      <div className="uc-model-list reveal">
        {chips.map((chip) => {
          const { name, tag } = splitModelChip(chip.label);
          return (
            <div key={chip.label} className="uc-model-row">
              <span className="uc-model-name">{name}</span>
              {tag && <span className="uc-model-tag">{tag}</span>}
            </div>
          );
        })}
      </div>
    );
  }

  return (
    <div className="uc-chip-row reveal">
      {chips.map((chip) => (
        <span key={chip.label} className="uc-chip">
          {chip.label}
        </span>
      ))}
    </div>
  );
}
